import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="card-stack"
export default class extends Controller {
  static targets = ['card'];

  connect() {
    this.activeIndex = this.cardTargets.length - 1;
    this.render();
  }

  activate(event) {
    if (event.type === 'keydown') event.preventDefault();

    this.activeIndex = Number(event.currentTarget.dataset.index);
    this.render();
  }

  render() {
    this.cardTargets.forEach((card, index) => {
      const isActive = index === this.activeIndex;

      card.classList.toggle('is-active', isActive);
      card.setAttribute('aria-expanded', isActive);
    });
  }
}
